
import { Link, useLocation } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { Navbar, Container, Nav } from 'react-bootstrap';

import { useState } from 'react';



const Navigation = (props) => {

	const {handleShow} = {...props}
	let location = useLocation();
	


	let handleLogout = (e) => {
		e.preventDefault();
		localStorage.clear();
		window.location.href = "/";
		
	}


	return (
		
		<>
			<Navbar bg="dark" variant="dark">
				<Container>
					<Navbar.Brand href="#home">EMAPTA | C.H.E.E.R.</Navbar.Brand>
					<Nav className="me-auto">
						<Link to="/admin" className='nav-link'>Home</Link>
						<Link to="/categories" className='nav-link'>Categories</Link>
						{/* <Link to="/sites" className='nav-link'>Sites</Link> */}
						<Link to="/notifications" className='nav-link'>Notifications</Link>
						<Link to="/logout" className='nav-link' onClick={e => handleLogout(e)} >Logout</Link>
						
					</Nav>

					<Nav className="d-flex">
						<Link to="#offcanvasRight" className='nav-link d-flex' data-bs-toggle="offcanvas" role="button" aria-controls="offcanvasExample" onClick={handleShow} ><i className="bi bi-funnel "></i></Link>
						
					</Nav>
				</Container>
			</Navbar>

			
		</>
	)

}

export default withOktaAuth(Navigation);